import React from 'react';
import PropTypes from 'prop-types'

import { FILTER_TYPE } from '../../../../../../../data/config/constants'
import { IMG_EMPTY } from '../../../../../../../data/assets/img'

import CheckboxGroupItem from '../../../../../../../components/form/checkboxgroupitem'
import RadioGroupWithMultiOptions from '../../../../../../../components/form/radiogroupwithmultioptions'
import ErrorBoundary from '../../../../../../../components/errorboundary'
import ShowMessage from '../../../../../../../components/showmessage'

class KpiFilter extends React.PureComponent {
  render() {
    const { filters, selected_filters, onChangeSelectedFilters, clearSelectedFilter } = this.props;
    if (filters.length > 0) {
      return (
        <div className="ori-tb-pad-10">
          <div className="ori-flex-row ori-flex-jsb ori-b-border-default ori-b-pad-15" >
            <p className="ori-font-bold">FILTERS</p>
            <p className="ori-font-13 ori-font-light-hover-primary" onClick={clearSelectedFilter}>CLEAR</p>
          </div>
          {
            filters.map((filter, index) => {
              switch (filter.type) {
                case FILTER_TYPE.CHECKBOX: return (
                  <ErrorBoundary key={index}>
                    <CheckboxGroupItem container_class="ori-tb-pad-5 ori-b-border-default" title={filter.title} options={filter.options} checked_items={selected_filters[filter.valueKey]} onChange={selected_value => onChangeSelectedFilters(selected_value, filter.valueKey)} show_search is_object_type_options />
                  </ErrorBoundary>
                );

                case FILTER_TYPE.RADIO_GROUP_WITH_MULTI_OPTIONS: return (
                  <ErrorBoundary key={index}>
                    <RadioGroupWithMultiOptions container_class="ori-t-pad-10 ori-b-border-default" display_data={filter} selected_data={selected_filters} onChange={onChangeSelectedFilters} />
                  </ErrorBoundary>
                )

                default: return null
              }
            })
          }
        </div>
      );
    }
    return (
      <div className="ori-tb-pad-10 ori-full-parent-height">
        <ShowMessage img_src={IMG_EMPTY} title="EMPTY" message="unable to load filter. please check your internet connection and reload the page." height={100} width={100} />
      </div>
    );
  }
}


KpiFilter.propTypes = {
  filters: PropTypes.array,
  selected_filters: PropTypes.object,
  onChangeSelectedFilters: PropTypes.func,
  clearSelectedFilter: PropTypes.func
}

KpiFilter.defaultProps = {
  filters: [],
  selected_filters: {}
}

export default KpiFilter;



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/analytics/kpi/components/kpifilter/index.js